// src/pages/PrivacyPolicySaitruptiCabs.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicySaitruptiCabs = () => {
  return (
    <div>
      <Helmet>
        <title>Saitrupti Cabs | Privacy Policy</title>
        <meta
          name="description"
          content="Saitrupti Cabs privacy policy outlining how we collect, use, and protect your personal information when you use our cab services."
        />
        <link rel="canonical" href="https://www.saitrupticabs.com/privacy-policy" />
      </Helmet>
      
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Privacy Policy</h1>
          </div>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At <b>Saitrupti Cabs</b>, we value your trust and are committed to maintaining the confidentiality and security of your personal information. This Privacy Policy outlines how we collect, use, store, and protect your data when you use our services.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  When you make a booking with us, we may collect details such as your name, phone number, email address, payment details, and travel information.
                </p>

                <p className="highlight darkcolor">2. Usage Information:</p>
                <p>
                  We collect information about your interactions with our website or app, including your IP address, device type, browser information, and pages visited.
                </p>

                <p className="highlight darkcolor">3. Location Information:</p>
                <p>
                  With your permission, we may collect location data to provide accurate pickup and drop-off services and improve route efficiency.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. To Provide Services:</p>
                <p>
                  Your information helps us process bookings, manage cab assignments, and deliver reliable transportation services.
                </p>

                <p className="highlight darkcolor">2. To Enhance Our Services:</p>
                <p>
                  We analyze usage patterns and customer feedback to improve our operations, technology, and user experience.
                </p>

                <p className="highlight darkcolor">3. For Communication:</p>
                <p>
                  We may use your contact details to send booking confirmations, ride updates, and important service-related notifications.
                </p>

                <p className="highlight darkcolor">4. For Marketing and Offers:</p>
                <p>
                  With your consent, we may send promotional offers, discounts, and service updates via email, SMS, or other channels.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing and Disclosure:</p>

                <p className="highlight darkcolor">1. Third-Party Service Providers:</p>
                <p>
                  We may share information with trusted third parties who assist in operations such as payment processing, analytics, and customer support.
                </p>

                <p className="highlight darkcolor">2. Legal Requirements:</p>
                <p>
                  We may disclose information when required by law or in response to valid legal requests to protect our rights or prevent fraud or misuse.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information. However, please note that no system is entirely secure.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You may request access, correction, or deletion of your personal information, and you may opt out of receiving promotional messages at any time.
                </p>

                <p className="highlight darkcolor">Changes to this Privacy Policy:</p>
                <p>
                  Saitrupti Cabs reserves the right to update or modify this Privacy Policy as needed. Any changes will be posted on this page with an updated effective date.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or concerns about our privacy policy, please reach out to us:</p>
            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+918390907004">+91 8390907004</a> {/* Update with actual contact */}
              </li>
              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@saitrupticabs.com">booking@saitrupticabs.com</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicySaitruptiCabs;
